import {useTable, useColumns} from 'react-table'
import {CustomHeaderColumn} from './columns/CustomHeaderColumn'
import {CustomRow} from './columns/CustomRow'
import {useQueryResponseData, useQueryResponseLoading} from '../core/QueryResponseProvider'
import {permissionColumns} from './columns/columns'
import {PermissionLoading} from '../components/loading/PermissionLoading'
import {KTCardBody} from '../../../../../../_metronic/helpers'
import {PermissonPagination} from '../components/pagination/PermissonPagination'
import PermissonVisibilityModal from '../components/modal/PermissonVisibilityModal'

const PermissionsTable = ({printRef, show, setShow}) => {
  const permissions = useQueryResponseData()
  const isLoading = useQueryResponseLoading()
  const data = permissions
  const columns = permissionColumns

  const {
    getTableProps,
    getTableBodyProps,
    headers,
    rows,
    prepareRow,
    state: {hiddenColumns},
    setHiddenColumns,
  } = useTable(
    {
      columns,
      data,
    },
    useColumns
  )

  return (
    <KTCardBody className='py-4'>
      {show && (
        <PermissonVisibilityModal
          setShow={setShow}
          hiddenColumns={hiddenColumns}
          headers={headers}
          columns={columns}
          setHiddenColumns={setHiddenColumns}
        />
      )}
      <div className='table-responsive'>
        <table
          id='kt_table_users'
          ref={printRef}
          className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          {...getTableProps()}
        >
          <thead>
            <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
              {headers.map((header) => {
                switch (header.isVisible) {
                  case false:
                    return null
                  case true:
                    return <CustomHeaderColumn key={header.id} column={header} />
                  default:
                    return null
                }
              })}
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold' {...getTableBodyProps()}>
            {rows.length > 0 ? (
              rows.map((row, i) => {
                prepareRow(row)
                return <CustomRow row={row} key={`row-${i}-${row.id}`} />
              })
            ) : (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No matching records found
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <PermissonPagination />
      {isLoading && <PermissionLoading />}
    </KTCardBody>
  )
}

export {PermissionsTable}
